import React from "react";
import { Globe, ShieldCheck, Users, Sparkles } from "lucide-react";

const stats = [
  { num: "10+", label: "Global Partners" },
  { num: "50+", label: "Projects Delivered" },
  { num: "5+", label: "Countries Served" },
];

const features = [
  { icon: <Globe size={20} />, title: "Global Reach", body: "Serving clients across 5+ countries with reliable import/export services", cls: "" },
  { icon: <ShieldCheck size={20} />, title: "Quality Assurance", body: "Certified solutions from leading technology manufacturers worldwide", cls: "green" },
  { icon: <Users size={20} />, title: "Expert Team", body: "Experienced professionals with deep industry knowledge", cls: "red" },
  { icon: <Sparkles size={20} />, title: "Innovation Focus", body: "Cutting-edge AI and emerging technology integration", cls: "" },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="snap-section">
      <div className="max-w-[1280px] mx-auto px-6 w-full">
        <div className="max-w-3xl mb-8">
          <div className="section-eyebrow">Who we are</div>
          <h2 className="section-title" data-testid="about-title">
            About EmirATech Distribution
          </h2>
          <p className="section-subtitle" data-testid="about-body">
            Leading provider of air traffic management and IT solutions, specializing in
            import and export of cutting-edge hardware, software, and AI-driven technologies.
            Headquartered in the UAE, we serve customers across the Middle East and Central Asia.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          {stats.map((s, i) => (
            <div key={s.label} data-testid={`about-stat-${i}`} className="glass-card p-5">
              <div className="stat-num" style={{ fontSize: "clamp(30px, 4vw, 42px)" }}>{s.num}</div>
              <div className="text-[#a6b3c8] mt-2 text-xs uppercase tracking-wider" style={{ fontFamily: "Sora, sans-serif" }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((f, i) => (
            <div key={f.title} data-testid={`about-feature-${i}`} className="glass-card p-5">
              <div className={`svc-icon ${f.cls} mb-4`} style={{ width: 44, height: 44 }}>{f.icon}</div>
              <h3 className="text-white text-base font-semibold mb-1.5" style={{ fontFamily: "Sora, sans-serif" }}>
                {f.title}
              </h3>
              <p className="text-[#a6b3c8] text-[13px] leading-relaxed">{f.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
